.deletedItem {
  text-decoration: line-through;
}

.closeLink {
  margin-left: 1rem;
  font-size: 0.75rem;
  font-weight: 400;
  cursor: pointer;
  text-decoration: underline;
}

.form {
  padding: 0;
}

.row {
  display: grid;
  grid-template-columns: minmax(0, 5fr) minmax(0, 1fr);
  gap: 1rem;
  align-items: end;
  margin-bottom: 1rem;
}

.inputContainer {
  margin: 0;
}

.inputField {
  margin-bottom: 0;
}
